<!--营销服务常用布局-->
<template>
  <section class="MarketingView-root">
    <header class="header" v-if="showHeader">
      <h3 class="header-left">
        <slot name="left"></slot>
      </h3>
      <div class="header-right">
        <slot name="right"></slot>
      </div>
    </header>
    <slot></slot>
  </section>
</template>
<script>
  export default {
    name       : 'MarketingView',
    components : {},
    props      : {
      showHeader : {
        type    : Boolean,
        default : true,
      },
    },
    data(){
      return {};
    },
    computed   : {},
    created(){},
    methods    : {},
  };
</script>
<style scoped lang="scss">
  .MarketingView-root{width: $center-width;background: #fff;border: 1px solid #e5e5e5;border-radius: 6px;padding: 30px;
    > * + *{margin-top: 30px;}
  }
  .header{display: flex;align-items: center;justify-content: space-between;
    &-left{padding-left: 10px;font-size: 14px;position: relative;
      &::before{content: '';width: 2px;height: 14px;background: $primary-color;
        position: absolute;left: 0;top: 50%;transform: translateY(-50%);
      }
    }
  }
</style>
